import { Host, h } from "@stencil/core";
export class CardTitle {
    constructor() {
        this.inverted = false;
    }
    render() {
        return (h(Host, { key: 'b12a4f08d1a78e31aa306b20ee59a8826249b5b0', class: "bal-card-title" }, h("bal-heading", { key: 'a22c6af75f714e70f1efd36f0671a6e623a9ef31', level: "h3", space: "none", inverted: this.inverted }, h("slot", { key: '11483681e586eac535db5244f4c85a87d0ddce42' }))));
    }
    static get is() { return "bal-card-title"; }
    static get properties() {
        return {
            "inverted": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If `true` the card text color becomes white."
                },
                "getter": false,
                "setter": false,
                "attribute": "inverted",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
}
